(function () {
    'use strict';

    angular.module('icheck', []).directive('icheck', function ($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    const value = $attrs.value,
                        jqElement = jQuery(element);

                    var valueIfTrue = undefined;
                    $scope.$watch($attrs.ngCheckedIfTrue, function (newValue) {
                        valueIfTrue = newValue;
                    });

                    var valueIfFalse = undefined;
                    $scope.$watch($attrs.ngCheckedIfFalse, function (newValue) {
                        valueIfFalse = newValue;
                    });

                    // to enable setViewValue
                    ngModel.$parsers = [];
                    if (ngModel.$options) {
                        ngModel.$options.updateOnDefault = true;
                    }

                    function update(checked) {
                        if (!!jqElement.data('parsley-multiple')) {
                            jqElement.parsley().validate();
                        }

                        const newValue = checked ? ('undefined' !== typeof valueIfTrue ? valueIfTrue : value) : 'undefined' !== typeof valueIfFalse ? valueIfFalse : false;

                        ngModel.$setViewValue(newValue);
                    }

                    jqElement
                        .iCheck({
                            checkboxClass: $attrs.checkboxClass || 'icheckbox_md',
                            radioClass: $attrs.radioClass || 'iradio_md',
                            increaseArea: '20%',
                        })
                        .on('ifChanged', function (e) {
                            $scope.$apply(function () {
                                update(!!e.target.checked);
                            });
                        });

                    $scope.$watch($attrs.ngDisabled, function (isDisabled) {
                        jqElement.iCheck(isDisabled ? 'disable' : 'enable');
                        jqElement.iCheck('update');
                    });

                    $scope.$watch(
                        $attrs.ngChecked,
                        function (isChecked) {
                            if (isChecked) {
                                return $timeout(function () {
                                    jqElement.iCheck('check');
                                });
                            }

                            if (typeof isChecked === 'undefined') {
                                isChecked = !!ngModel.$viewValue;
                            }

                            update(isChecked);
                        },
                        true
                    );

                    $scope.$watch(
                        $attrs.ngModel,
                        function () {
                            jqElement.iCheck('update');
                        },
                        true
                    );
                });
            },
        };
    });
})();
